import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchListings(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/ebayListings/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
      sort: payload.filters.sort,
    }
  });
  yield put({
    // $global: true,
    type: 'SET_LISTINGS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_LISTINGS', fetchListings),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/Listings.sagas.js